export default "__VITE_ASSET__C2KI5_4m__"